import { Divider } from "@chakra-ui/react";
import { AccountIntegrationTypeEnum } from "enums/account-integration-type.enum";
import { ApiRequestStatusEnum } from "enums/api-request-status.enum";
import { Error, Loader } from "components";
import { observer } from "mobx-react";
import React, { FC, useEffect, useState } from "react";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import {
  TAccountIntegrationData,
  TMRIRadarConfig,
} from "types/account-integration.type";
import { SyncConfigurator } from "../SyncConfigurator";
import { MRIRadarIntegrationForm } from "./MRIRadarIntegrationForm";
import { MRIRadarIntegrationNegotiatorsConfigurator } from "./MRIRadarIntegrationNegotiatorsConfigurator/MRIRadarIntegrationNegotiatorsConfigurator";
import { MRIRadarIntegrationDefaultNegotiatorConfigurator } from "./MRIRadarIntegrationDefaultNegotiatorConfigurator/MRIRadarIntegrationDefaultNegotiatorConfigurator";

interface IProps {
  accountStore: UserAccountStore;
}

export const MRIRadarIntegrationConfigurator: FC<IProps> = observer(
  ({ accountStore }) => {
    const [loadingStatus, setLoadingStatus] = useState(
      ApiRequestStatusEnum.NONE
    );

    const accountUsersStore = accountStore.accountUsersStore;
    const accountIntegrationsStore = accountStore.accountIntegrationsStore;
    const isManuallyTriggered =
      accountIntegrationsStore.hasActiveManualMRIRadarIntegration;
    const accountIntegrationMRIRadarNegotiatorsStore =
      accountIntegrationsStore.accountIntegrationMRIRadarStore
        .accountIntegrationMRIRadarNegotiatorsStore;

    const accountIntegration = accountIntegrationsStore
      .accountIntegrationsMapByType[
      AccountIntegrationTypeEnum.MRI_RADAR
    ] as TAccountIntegrationData<TMRIRadarConfig>;

    useEffect(() => {
      const fetchData = async () => {
        try {
          setLoadingStatus(ApiRequestStatusEnum.PENDING);
          await Promise.all([
            accountUsersStore.fetchAccountUsers(),
            accountIntegrationMRIRadarNegotiatorsStore.fetchAccountMRIRadarNegotiatorsRelations(),
            accountIntegrationMRIRadarNegotiatorsStore.fetchMRIRadarDefaultNegotiator(),
          ]);
          setLoadingStatus(ApiRequestStatusEnum.SUCCESS);
        } catch (e) {
          setLoadingStatus(ApiRequestStatusEnum.ERROR);
        }
      };

      fetchData();
    }, [accountUsersStore, accountIntegrationMRIRadarNegotiatorsStore]);

    return (
      <>
        <MRIRadarIntegrationForm
          accountIntegrationsStore={accountIntegrationsStore}
        />
        <Divider my={6} />
        <SyncConfigurator
          accountIntegrationsStore={accountIntegrationsStore}
          accountIntegration={accountIntegration}
        />
        {loadingStatus === ApiRequestStatusEnum.PENDING && <Loader />}
        {loadingStatus === ApiRequestStatusEnum.ERROR && <Error />}
        {loadingStatus === ApiRequestStatusEnum.SUCCESS && (
          <>
            <MRIRadarIntegrationDefaultNegotiatorConfigurator
              accountStore={accountStore}
              isManuallyTriggered={isManuallyTriggered}
            />
            <MRIRadarIntegrationNegotiatorsConfigurator
              accountStore={accountStore}
              isManuallyTriggered={isManuallyTriggered}
            />
          </>
        )}
      </>
    );
  }
);
